"use strict";

var _slicedToArray = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var _ = require("lodash");

var debug = require('debug')('routing-controllers-openapi');

var decorators_1 = require("./decorators");

var defaultConverters_1 = require("./defaultConverters");

var options_1 = require("./options");

var decorators_2 = require("./decorators");

exports.JSONSchema = decorators_2.JSONSchema;

function validationMetadatasToSchemas(metadatas, userOptions) {
  var options = Object.assign({}, options_1.defaultOptions, userOptions);

  var schemas = _(metadatas).groupBy('target.name').mapValues(function (ownMetas) {
    var target = ownMetas[0].target;
    var metas = ownMetas.concat(getInheritedMetadatas(target, metadatas));

    var properties = _(metas).groupBy('propertyName').mapValues(function (propMetas, propKey) {
      var schema = applyConverters(propMetas, options);
      return applyDecorators(schema, target, options, propKey);
    }).value();

    var definitionSchema = {
      properties: properties,
      type: 'object'
    };
    var required = getRequiredPropNames(target, metas, options);

    if (required.length > 0) {
      definitionSchema.required = required;
    }

    return applyDecorators(definitionSchema, target, options, target.name);
  }).value();

  return schemas;
}

exports.validationMetadatasToSchemas = validationMetadatasToSchemas;

function getInheritedMetadatas(target, metadatas) {
  return metadatas.filter(function (d) {
    return d.target instanceof Function && target.prototype instanceof d.target && !_.find(metadatas, {
      propertyName: d.propertyName,
      target: target,
      type: d.type
    });
  });
}

function applyConverters(propertyMetadatas, options) {
  var converters = Object.assign({}, defaultConverters_1.defaultConverters, options.additionalConverters);

  var convert = function convert(meta) {
    var converter = converters[meta.type];

    if (!converter) {
      debug('No schema converter found for validation metadata', meta);
      return {};
    }

    var items = _.isFunction(converter) ? converter(meta, options) : converter;
    return meta.each ? {
      items: items,
      type: 'array'
    } : items;
  };

  return _.merge.apply(_, [{}].concat(_toConsumableArray(propertyMetadatas.map(convert))));
}

function applyDecorators(schema, target, options, propertyName) {
  var additionalSchema = decorators_1.getMetadataSchema(target.prototype, propertyName);
  return _.isFunction(additionalSchema) ? additionalSchema(schema, options) : _.merge({}, schema, additionalSchema);
}

function getRequiredPropNames(target, metadatas, options) {
  function isDefined(metas) {
    return _.some(metas, {
      type: class_validator_1.ValidationTypes.IS_DEFINED
    });
  }

  function isOptional(metas) {
    return _.some(metas, function (_ref) {
      var type = _ref.type;
      return _.includes([class_validator_1.ValidationTypes.CONDITIONAL_VALIDATION, class_validator_1.ValidationTypes.IS_EMPTY], type);
    });
  }

  return _(metadatas).groupBy('propertyName').pickBy(function (metas) {
    var _$partition = _.partition(metas, function (d) {
      return d.target === target;
    }),
        _$partition2 = _slicedToArray(_$partition, 2),
        own = _$partition2[0],
        inherited = _$partition2[1];

    return options.skipMissingProperties ? isDefined(own) || !isOptional(own) && isDefined(inherited) : !(isOptional(own) || isOptional(inherited));
  }).keys().value();
}